import { useAppSelector } from 'hooks';
import analytics from 'modules/analytics';
import { useCallback } from 'react';

const useLogEvent = (augmentPayload?: Record<string, unknown>) => {
  const userId = useAppSelector(str => str.auth.userId);
  const status = useAppSelector(str => str.status);

  const {
    teacher_classroom_id: teacherClassroomId,
    student_classroom_id: studentClassroomId,
    teacher_id: teacherId,
    in_class: inClass,
  } = status || {};

  const logEvent = useCallback(
    (type: string, payload: Record<string, unknown> = {}) => {
      const data = {
        in_class: inClass,
        student_classroom_id: studentClassroomId,
        student_id: userId,
        teacher_classroom_id: teacherClassroomId,
        teacher_id: teacherId,
        user_id: userId,
        timestamp: Date.now(),
        ...(payload || {}),
        ...(augmentPayload || {}),
      };

      analytics.trackEvent(type, data);
    },
    [augmentPayload, inClass, studentClassroomId, teacherClassroomId, teacherId, userId],
  );

  return logEvent;
};

export default useLogEvent;
